export enum PaymentReadinessStatus {
  READY = "READY",
  SETUP_PAY = "SETUP_PAY",
}
